import script from "./customDashboardItem.vue?vue&type=script&setup=true&lang=js"
export * from "./customDashboardItem.vue?vue&type=script&setup=true&lang=js"

import "./customDashboardItem.vue?vue&type=style&index=0&id=01c469ae&lang=scss&scoped=true"
import "./customDashboardItem.vue?vue&type=style&index=1&id=01c469ae&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c469ae"]])

export default __exports__